import React from 'react';
import {Header} from '@amzn/awsui-components-react';

export default function Help() {
    return (
        <div className={'mainArea'}>
            <Header variant="h1">Help</Header>
            <a
                href="https://w.amazon.com/bin/view/F3/F3_Grocery_Supply_Chain/Sales_And_Operations_Planning/Excelsior/FAQ#HFurthersupport"
                className="awsui-util-font-size-3"
                target={'_blank'}
                rel={'noopener noreferrer'}
            >
                Further Support
            </a>
        </div>
    );
}
